import {useEffect, useRef, useState} from 'react';
import {InlineLinkProps} from '../InlineLinkClickHandler';
import {LinkableMarkdownText} from '../LinkableMarkdownText';
import {useAnalytics} from '../../../AnalyticsProvider';

export type StructuredContentCompatProps = {
  structuredContent: string;
  onComplete: () => void;
  isDone?: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  messageId: string;
};

export function StructuredContentCompat({
  structuredContent,
  onComplete,
  isDone,
}: StructuredContentCompatProps) {
  const analytics = useAnalytics();

  const data = useRef<Record<string, unknown> | null>(null);
  const [text, setText] = useState<string | null>(null);
  const hasCalledComplete = useRef(false);

  useEffect(() => {
    if (data.current) {
      return;
    }
    data.current = JSON.parse(structuredContent) as Record<string, unknown>;
    const content = (data.current.text as string | undefined)?.trim();
    setText(content ?? '');
  }, [structuredContent]);

  useEffect(() => {
    if (text !== null && !isDone && !hasCalledComplete.current) {
      hasCalledComplete.current = true;
      onComplete();
    }
  }, [text, isDone, onComplete]);

  if (!text || text === '') {
    return null;
  }

  return (
    <LinkableMarkdownText
      body={text}
      onLinkClick={({href, innerText, parentInnerText}: InlineLinkProps) => {
        analytics.action(
          'universal_help_live_answers_frontend_inline_link_clicked',
          {
            live_answers_source_url: href,
            live_answers_source_title: innerText,
            live_answers_source_context: parentInnerText,
          },
        );
      }}
    />
  );
}
